module.exports = __webpack_public_path__ + "fj.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/fj.svg
// module id = 543
// module chunks = 0